export * from './IconCheckBadge';
export { default as IconCheckBadge } from './IconCheckBadge';
